import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";

import { EventTypes } from "src/app/core/constants/event-types";
import { ContactsService } from "../../../../core/api/services/contacts.service";
import { BaseFormPageComponent } from "../../../shared/base/components/base-form-page.component";
import { GetPhonebooksWithPaginationDto } from "./../../../../core/models/phonebook-tree.model";
import { CommonModule } from "@angular/common";
import { BaseFormModule } from "src/app/shared/components/base/base-component/base-form.module";
import { DeleteContactByCellPhoneComponent } from "../delete-contact-by-cellphone/delete-contact-by-cellphone.component";

@Component({
    selector: "app-contacts-number-list-form",
    templateUrl: "./contacts-number-list-form.component.html",
    imports: [BaseFormModule, DeleteContactByCellPhoneComponent]
})
export class ContactsNumberListForm
  extends BaseFormPageComponent
  implements OnInit
{
  model: string;
  deletePhonebookIdsModel: Array<number> = [];
  deleteContactsFromPhonebooksByCellPhoneInput;
  @Input("selectedPhonebook") selectedPhonebook: GetPhonebooksWithPaginationDto;
  @Input() phonebookTitle: string;

  constructor(protected currentService: ContactsService) {
    super();
  }

  ngOnInit() {
    this.getVocabs();
    this.initForm();
    this.fields = "pages.contacts.importfromfile.fields.";
  }

  initForm() {
    this.form = new FormGroup({
      phonebookIds: new FormControl(),
      phonebook: new FormControl(this.phonebookTitle),
      contactsNumberList: new FormGroup({
        numbers: new FormControl("", Validators.required),
      }),
    });
    try {
      this.form.controls["phonebook"].disable();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  //#region Api

  baseCreateApi(numberList: string) {
    this.unSubs();

    this.loading = true;

    if (this.deletePhonebookIdsModel?.length > 0) {
      this.deleteContactsFromPhonebooksByCellPhoneInput = {};
      this.deleteContactsFromPhonebooksByCellPhoneInput.phonebookIds =
        this.deletePhonebookIdsModel;
    } else this.deleteContactsFromPhonebooksByCellPhoneInput = undefined;

    this.currentService
      .contactsCreateContactFromNumbersListPost({
        body: {
          numbers: numberList,
          phonebookId: this.selectedPhonebook.id,
          deleteContactsFromPhonebooksByCellPhoneInput:
            this.deleteContactsFromPhonebooksByCellPhoneInput,
        },
      })
      .pipe(this.basePipeOperators())
      .subscribe((result) => {
        this.apiNotificationService.notifyMessage({ result });
        if (result.isSucceed) this.onSuccess();
      });
  }

  baseUpdateApi(model: any): void {}

  //#endregion

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;
    this.baseCreateApi(this.model);
  }
}
